// extracted by mini-css-extract-plugin
export default {"empty":"EmptyState_empty__naVmd","title":"EmptyState_title__qpA3H","body":"EmptyState_body__9BBts","action":"EmptyState_action__UmIoA"};